/*
 * ProjectActivityListPage Messages
 *
 * This contains all the text for the ProjectsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.publish.status';

export default defineMessages({
  inReview: {
    id: `${scope}.inReview`,
    defaultMessage: 'In Review',
  },
  publishedLive: {
    id: `${scope}.publishedLive`,
    defaultMessage: 'Published Live',
  },
  marketsLive: {
    id: `${scope}.marketsLive`,
    defaultMessage: 'Markets Live',
  },
  marketsInReview: {
    id: `${scope}.marketsInReview`,
    defaultMessage: 'Markets In Review',
  },
});
